import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { loginSuccess, logout } from "../redux/AuthSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getLoginAPIURL } from "../commonServices/LoginAPIURL";
import { toast } from "react-toastify";
import Loader from "./Loader";

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [loader, setLoader] = useState(false);

    useEffect(() => {
        // Clear session on entering login page
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("authUser");

        // Optional: Reset redux if logout action exists
        try {
            dispatch(logout());
        } catch { }
    }, []);


    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Username is required"),
            password: Yup.string().required("Password is required"),
        }),
        onSubmit: async (values) => {
            try {
                const loginObj = {
                    loginId: values.username,
                    password: values.password,
                };

                const response = await axios.post(getLoginAPIURL, loginObj);

                const userData = response.data.user;
                const token = response.data.token;

                // 🔥 Merge token inside user object
                const fullUser = {
                    ...userData,
                    token: token,
                };

                // 🔥 Save to Redux
                dispatch(
                    loginSuccess({
                        user: fullUser   // only user now
                    })
                );

                console.log(fullUser)
                // 🔥 Save merged object to sessionStorage
                sessionStorage.setItem("user", JSON.stringify(fullUser));

                // 🔥 Redirect based on role
                switch (userData.roleId) {
                    case 1:
                        navigate("/app/gate-entry");
                        break;
                    case 2:
                        navigate("/app/test-report");
                        break;
                    case 3:
                        navigate("/app/gate-entry");
                        break;
                    case 4:
                        navigate("/app/lab-report");
                        break;
                    default:
                        navigate("/");
                }

                setLoader(false);

            } catch (error) {
                console.error("Login error:", error);
                setLoader(false);
                toast.error("Invalid username or password");
            }
        }


    });

    if (loader == true) {
        return <Loader />
    }
    else {
        return (
            <div
                className="relative z-50 rounded-3xl p-6 sm:p-10 w-full max-w-sm shadow-2xl bg-white mx-auto"
            >
                <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center text-[#0F172A]">
                    Login
                </h2>

                <form onSubmit={formik.handleSubmit}>
                    {/* Username */}
                    <div className="mb-6">
                        <label className="block font-medium text-gray-700 mb-2">
                            Username
                        </label>

                        <input
                            type="text"
                            name="username"
                            onChange={formik.handleChange}
                            value={formik.values.username}
                            autoComplete="off"
                            className="w-full rounded-full px-5 py-3 border border-gray-300
                                   focus:outline-none focus:ring-4 focus:ring-blue-300 shadow-sm"
                            placeholder="Enter username"
                        />

                        {formik.errors.username && (
                            <p className="text-red-500 text-sm mt-1">
                                {formik.errors.username}
                            </p>
                        )}
                    </div>

                    {/* Password */}
                    <div className="mb-8">
                        <label className="block font-medium text-gray-700 mb-2">
                            Password
                        </label>

                        <input
                            type="password"
                            name="password"
                            onChange={formik.handleChange}
                            value={formik.values.password}
                            autoComplete="off"
                            className="w-full rounded-full px-5 py-3 border border-gray-300
                                   focus:outline-none focus:ring-4 focus:ring-blue-300 shadow-sm"
                            placeholder="Enter password"
                        />

                        {formik.errors.password && (
                            <p className="text-red-500 text-sm mt-1">
                                {formik.errors.password}
                            </p>
                        )}
                    </div>

                    {/* Button */}
                    <Button
                        type="submit"
                        className="w-full py-3 rounded-full shadow-lg text-white text-lg font-semibold 
                               transition-all hover:opacity-90"
                        style={{
                            background: "linear-gradient(135deg, #3B82F6, #1D4ED8)",
                            border: "none",
                        }}
                    >
                        Login
                    </Button>
                </form>
            </div>
        );
    }
};

export default Login;
